<template>
	<div>
		<!--New Research/Academy Plan-->
		<div style="display: inline-flex">
			<h1>Academy Plan</h1>
			<fileOptions :gridApi="gridApi" :importFile="false" />
		</div>
		<!--title="Academy Plan"-->
		<GenericTable
			:columnDefs="columnDefs"
			:rowData="rowData"
			:gridOptions="gridOptions"
			:singleRow="singleRow"
			@api="getApi"
			@updateTable="updateTable"
			tableStyle="height:700px"
		/>
	</div>
</template>
<script>
import tableEditor from "@/components/tableComponents/tableEditor.vue";
import tableLink from "@/components/tableComponents/tableLink.vue";
import tableAutoComplete from "@/components/tableComponents/tableAutoComplete.vue";
import fileOptions from "@/components/tableComponents/fileOptions.vue";

export default {
	name: "test-ResearchPlan",
	components: {
		// eslint-disable-next-line vue/no-unused-components
		tableEditor,
		// eslint-disable-next-line vue/no-unused-components
		tableLink,
		// eslint-disable-next-line vue/no-unused-components
		tableAutoComplete,
		fileOptions
	},
	data() {
		return {
			gridApi: null,
			gridOptions: {
				rowHeight: 180,
				defaultColDef: {
					width: 280 //default width of each column
				}
			},
			singleRow: {
				progress: false,
				tasks: "",
				toolDescription: "",
				toolLink: [],
				notes: "",
				peopleInvolved: ""
			},
			rowData: this.$tera.project.academyWizard.planTable.rows,
			columnDefs: this.$tera.project.academyWizard.planTable.headers1
		};
	},
	beforeMount() {
		this.columnDefs.forEach(col => {
			if (col.field == "toolDescription") {
				//col.cellRenderer = "tableEditor";
				this.$set(col, "cellRenderer", "tableEditor");
			}
			if (col.field == "toolLink") {
				//col.cellRenderer = "tableLink";
				this.$set(col, "cellRenderer", "tableLink");
			}
			if (col.field == "peopleInvolved") {
				//col.cellRenderer = "tableAutoComplete";
				this.$set(col, "cellRenderer", "tableAutoComplete");
				let cellRendererParams = {
					titlePageAuthors: this.$tera.project.author.map(el => {
						return { label: el };
					})
				};
				this.$set(col, "cellRendererParams", cellRendererParams);
			}
			if (col.field == "notes") {
				//col.cellRenderer = "tableEditor";
				this.$set(col, "cellRenderer", "tableEditor");
			}
		});
	},
	mounted() {
		this.rowData.map(row => {
			//console.log("row:", row);
			if (
				row.tasks == "Design systematic search strategy" ||
				row.tasks == "Run systematic search strings" ||
				row.tasks == "Deduplicate results"
			) {
				if (this.$tera.project.searchStrategyAuthors != null) {
					row.peopleInvolved = this.$tera.project.searchStrategyAuthors;
				}
			}
			if (
				row.tasks == "Citation search" &&
				this.$tera.project.conductSSearchAuthors != null
			) {
				row.peopleInvolved = this.$tera.project.conductSSearchAuthors;
			}
			if (
				row.tasks == "Screen abstracts" &&
				this.$tera.project.titleAbstractScreeners != null
			) {
				row.peopleInvolved = this.$tera.project.titleAbstractScreeners;
			}
			if (
				row.tasks == "Obtain full text" &&
				this.$tera.project.fullTextRetrivalAuthor != null
			) {
				row.peopleInvolved = this.$tera.project.fullTextRetrivalAuthor;
			}
			if (
				row.tasks == "Screen full text" &&
				this.$tera.project.fullTextScreeners != null
			) {
				row.peopleInvolved = this.$tera.project.fullTextScreeners;
			}
			if (
				row.tasks == "Screen trial registries" &&
				this.$tera.project.screenTrialRegisPeople != null
			) {
				row.peopleInvolved = this.$tera.project.screenTrialRegisPeople;
			}
			if (
				row.tasks == "Screen citation analysis" &&
				this.$tera.project.screenCitationSearchPeople != null
			) {
				row.peopleInvolved = this.$tera.project.screenCitationSearchPeople;
			}
			if (
				row.tasks == "Extract data" &&
				this.$tera.project.extractionAuthors != null
			) {
				row.peopleInvolved = this.$tera.project.extractionAuthors;
			}
			if (
				row.tasks == "Risk of Bias assessment" &&
				this.$tera.project.assessedRobAuthors != null
			) {
				row.peopleInvolved = this.$tera.project.assessedRobAuthors;
			}
			return row;
		});
	},
	methods: {
		getApi(api) {
			this.gridApi = api;

			//Add EventListener : for normal cell in ag-grid
			this.gridApi.forEachNode(node => {
				node.addEventListener("cellChanged", this.cellChangeHandler);
			});

			/*let editors = document.querySelectorAll(".el-textarea__inner");
			editors.forEach((editor) => {
				console.log(editor);
				editor.addEventListener("change", this.cellChangeHandler);
			});*/
		},
		downloadCSV() {
			this.$prompt("New File Name:", "Download CSV File", {
				confirmButtonText: "Download",
				cancelButtonText: "Cancel"
			})
				.then(filename => {
					//download as a CSV File
					this.gridApi.csvCreator.exportDataAsCsv({
						processCellCallback: params => {
							if (params.column.colId == "toolLink") {
								return params.value.map(el => {
									return el.name;
								});
							}
							if (params.column.colId == "peopleInvolved") {
								if (params.value != "") {
									return params.value.map(el => {
										return el.label;
									});
								}
							}
							return params.value;
						},
						fileName: filename.value
					});

					this.$message({
						type: "success",
						message: "Download Successfully!"
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "Cancel downloading file"
					});
				});
		},
		//Push column & row changes from ag-grid to $terafy
		//FIXME: currently this trigger to save is muanual even has binded $tera.project
		updateTable(event) {
			//Row $tera.project change
			if (event.e == "Row") {
				event.dir == 0
					? this.$tera.project.academyWizard.planTable.rows.splice(event.rn.childIndex, 1)
					: this.$tera.project.academyWizard.planTable.rows.splice(
							event.rn.childIndex,
							0,
							event.rn.data
					  );
				//Add Listener for monioring the new node contents change

				//event.rn.addEventListener("cellChanged", this.cellChangeHandler);
				this.gridApi.forEachNode(n => {
					if (n.childIndex == event.rn.childIndex) {
						n.addEventListener("cellChanged", this.cellChangeHandler);
					}
				});
			}
			//Column $tera.project change
			if (event.changeEvent == "Column") {
				console.log("col:", event);
				event.Dir == 0
					? this.$tera.project.academyWizard.planTable.headers1.splice(
							event.ColInfo.selectedIndex,
							1
					  )
					: event.Dir > 0
					? this.$tera.project.academyWizard.planTable.headers1.splice(
							event.ColInfo.selectedIndex,
							0,
							event.ColInfo.col
					  )
					: this.$tera.project.academyWizard.planTable.headers1.splice(
							event.ColInfo.selectedIndex + 1,
							0,
							event.ColInfo.col
					  );
			}
		},
		cellChangeHandler(e) {
			//console.log("cellContents:", e);
			this.$tera.project.academyWizard.planTable.rows[e.node.childIndex] = e.node.data;
			//console.log("after:", this.$tera.project.academyWizard.planTable.rows[e.node.childIndex]);
		}
	}
};
</script>
<style scoped>
.el-button--text {
	padding-top: 12%;
	font-size: 20px;
}
</style>
